import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "page-form-nav py-3 shadow bg-white border-top border-black-10 sticky-top" }
const _hoisted_2 = {
  key: 0,
  class: "container"
}
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-3" }
const _hoisted_5 = { class: "col-6 text-center" }
const _hoisted_6 = { class: "col-3 text-end" }
const _hoisted_7 = {
  class: "dropdown-menu dropdown-menu-end",
  "aria-labelledby": "dropdown-form-area-link"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("hr", { class: "dropdown-divider" })
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("hr", { class: "dropdown-divider" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SVGArrowLeft = _resolveComponent("SVGArrowLeft")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ApplicationStateComponent = _resolveComponent("ApplicationStateComponent")!
  const _component_BadgeRound = _resolveComponent("BadgeRound")!
  const _component_Dropdown = _resolveComponent("Dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.hasCurrentApplication)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_router_link, {
                to: _ctx.linkToOverview,
                class: "text-decoration-none"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_SVGArrowLeft, { class: "me-1" }),
                  _createTextVNode(" " + _toDisplayString(_ctx.linkToOverviewTitle), 1)
                ]),
                _: 1
              }, 8, ["to"])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("span", null, [
                _createTextVNode(_toDisplayString(_ctx.$t('text.application_short', { year: _ctx.getCurrentApplicationPeriod(_ctx.periodOfApplication) })) + " ", 1),
                _createVNode(_component_ApplicationStateComponent, {
                  state: _ctx.application.state
                }, null, 8, ["state"])
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_Dropdown, {
                label: _ctx.$t('links.goto_form_area'),
                class: "dropdown-toggle text-decoration-none",
                role: "button",
                id: "dropdown-form-area-link",
                "aria-expanded": "false"
              }, {
                main: _withCtx(() => [
                  _createElementVNode("ul", _hoisted_7, [
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, {
                        to: { name: 'FormView', params: { id: _ctx.getFormIdForFormType(_ctx.localFormTypes.FormTypeGeneralInformation) }},
                        class: "dropdown-item d-flex align-items-center",
                        "active-class": `bg-secondary-alt-0${_ctx.localFormTypes.FormTypeGeneralInformation} text-white`
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_BadgeRound, {
                            label: _ctx.$t('action_fields.basic_information'),
                            class: _normalizeClass(`bg-secondary-alt-0${_ctx.localFormTypes.FormTypeGeneralInformation}-15`)
                          }, null, 8, ["label", "class"]),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('action_fields.basic_information')), 1)
                        ]),
                        _: 1
                      }, 8, ["to", "active-class"])
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, {
                        to: { name: 'FormView', params: { id: _ctx.getFormIdForFormType(_ctx.localFormTypes.FormTypeStatisticalInformation) }},
                        class: "dropdown-item d-flex align-items-center",
                        "active-class": `bg-secondary-alt-0${_ctx.localFormTypes.FormTypeStatisticalInformation} text-white`
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_BadgeRound, {
                            label: _ctx.$t('action_fields.statistical_information'),
                            class: _normalizeClass(`bg-secondary-alt-0${_ctx.localFormTypes.FormTypeStatisticalInformation}-15`)
                          }, null, 8, ["label", "class"]),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('action_fields.statistical_information')), 1)
                        ]),
                        _: 1
                      }, 8, ["to", "active-class"])
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, {
                        to: { name: 'FormView', params: { id: _ctx.getFormIdForFormType(_ctx.localFormTypes.FormTypeBasicUnderstanding) }},
                        class: "dropdown-item d-flex align-items-center",
                        "active-class": `bg-secondary-alt-0${_ctx.localFormTypes.FormTypeBasicUnderstanding} text-white`
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_BadgeRound, {
                            label: _ctx.$t('action_fields.our_base_values'),
                            class: _normalizeClass(`bg-secondary-alt-0${_ctx.localFormTypes.FormTypeBasicUnderstanding}-15`)
                          }, null, 8, ["label", "class"]),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('action_fields.our_base_values')), 1)
                        ]),
                        _: 1
                      }, 8, ["to", "active-class"])
                    ]),
                    _hoisted_8,
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, {
                        to: { name: 'FieldOfActionOverview', params: { id: _ctx.application.id }},
                        class: "dropdown-item d-flex align-items-center",
                        "active-class": "bg-secondary-alt-04 text-white"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_BadgeRound, {
                            label: _ctx.$t('action_fields.title'),
                            class: "bg-secondary-alt-04-15"
                          }, null, 8, ["label"]),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('action_fields.title')), 1)
                        ]),
                        _: 1
                      }, 8, ["to"])
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fieldsOfActions, (field, index) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: field.id
                      }, [
                        _createVNode(_component_router_link, {
                          to: { name: 'FieldOfActionDetails', params: { id: field.id }},
                          class: "dropdown-item d-flex align-items-center",
                          "active-class": "bg-secondary-alt-04 text-white"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" – " + _toDisplayString(_ctx.$t('fields_of_action.short_name_number', { number: index + 1 })) + " " + _toDisplayString(_ctx.$t(_ctx.getShortNameOfField(field.field_of_action_type))), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]))
                    }), 128)),
                    _hoisted_9,
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, {
                        to: { name: 'ApplicationActionOverview', params: { id: _ctx.application.id }},
                        class: "dropdown-item d-flex align-items-center",
                        "active-class": "bg-primary text-white"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('meta.pageTitles.actions_overview')), 1)
                        ]),
                        _: 1
                      }, 8, ["to"])
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["label"])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}